import {
  GET_AUTHENTICATED,
  SET_APIKEY,
  GET_APIKEY,
  REMOVE_APIKEY,
  SET_TOKEN,
  GET_TOKEN,
  REMOVE_TOKEN,
  GET_REFRESH_TOKEN,
  SET_REFRESH_TOKEN,
  REMOVE_REFRESH_TOKEN,
} from './types';

import { storage } from '@/utils/storage';

const state = () => ({
  api_key: null,
  token: null,
  refresh_token: storage.getItem('refresh_token') || null,
});

const getters = {
  [GET_AUTHENTICATED]: (state: any) => !!state.refresh_token,
  [GET_APIKEY]: (state: any) => state.api_key,
  [GET_TOKEN]: (state: any) => state.token,
  [GET_REFRESH_TOKEN]: (state: any) => state.refresh_token,
};

const mutations = {
  [SET_APIKEY](state: any, api_key: string) {
    state.api_key = api_key;
  },
  [REMOVE_APIKEY](state: any) {
    state.api_key = null;
  },
  [SET_TOKEN](state: any, token: string) {
    state.token = token;
  },
  [REMOVE_TOKEN](state: any) {
    state.token = null;
  },
  [SET_REFRESH_TOKEN](state: any, refresh_token: string) {
    state.refresh_token = refresh_token;
  },
  [REMOVE_REFRESH_TOKEN](state: any) {
    state.refresh_token = null;
  },
};

const actions = {
  [SET_APIKEY](context: any, api_key: string) {
    context.commit(SET_APIKEY, api_key);
  },
  [REMOVE_APIKEY](context: any) {
    context.commit(REMOVE_APIKEY);
  },
  [SET_TOKEN](context: any, api_key: string) {
    context.commit(SET_TOKEN, api_key);
  },
  [REMOVE_TOKEN](context: any) {
    context.commit(REMOVE_TOKEN);
  },
  [SET_REFRESH_TOKEN](context: any, refresh_token: string) {
    storage.setItem('refresh_token', refresh_token);
    context.commit(SET_REFRESH_TOKEN, refresh_token);
  },
  [REMOVE_REFRESH_TOKEN](context: any) {
    storage.removeItem('refresh_token');
    context.commit(REMOVE_REFRESH_TOKEN);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
